import area from "@turf/area";
import kinks from "@turf/kinks";

export const getContrastColor = (hex) => {
    const r = parseInt(hex.substr(1,2),16);
    const g = parseInt(hex.substr(3,2),16);
    const b = parseInt(hex.substr(5,2),16);

    const srgb = [r,g,b].map(v => {
        v /= 255;
        return v <= 0.03928 ? v/12.92 : Math.pow((v+0.055)/1.055, 2.4);
    });
    const luminance = 0.2126*srgb[0] + 0.7152*srgb[1] + 0.0722*srgb[2];

    return luminance > 0.7 ? "#000" : "#fff";
}

export const hexToRgba = (hex, alpha = 1, darkMode = false) => {
    if (typeof hex !== 'string') {
        throw new TypeError('HEX color must be a string');
    }

    if (!/^#(?:[A-Fa-f0-9]{3}|[A-Fa-f0-9]{6})$/.test(hex)) {
        throw new Error(`Invalid HEX color: ${hex}`);
    }

    let normalizedHex = hex.slice(1);

    if (normalizedHex.length === 3) {
        normalizedHex = normalizedHex
            .split('')
            .map(char => char.repeat(2))
            .join('');
    }

    let r = parseInt(normalizedHex.slice(0, 2), 16);
    let g = parseInt(normalizedHex.slice(2, 4), 16);
    let b = parseInt(normalizedHex.slice(4, 6), 16);

    if (darkMode) {
        const darkenFactor = 0.7;

        r = Math.round(r * darkenFactor);
        g = Math.round(g * darkenFactor);
        b = Math.round(b * darkenFactor);
    }

    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const getPolygonFeature = (coords = []) => {
    const coordinates = coords.map(point => [
        Number(point.lng),
        Number(point.lat)
    ]);

    if (coordinates.length > 0) {
        const first = coordinates[0];
        const last = coordinates[coordinates.length - 1];

        if (first && (first[0] !== last[0] || first[1] !== last[1])) {
            coordinates.push([...first]);
        }
    }

    return {
        type: 'Feature',
        geometry: {
            type: 'Polygon',
            coordinates: [coordinates]
        }
    };
}

export const isSimplePolygon = (coords = []) => {
    if (coords.length < 3) {
        return false;
    }

    const feature = getPolygonFeature(coords);

    return kinks(feature).features.length === 0;
};

export const getPolygonAreaAcres = (coords = []) => {
    const squareMeters = area(
        getPolygonFeature(coords)
    );

    return squareMeters * 0.000247105; // acres
};
